/* global $ */
import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import DeliveryMode from "./DeliveryMode"; // on l'importe
import "./Checkout.css";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function CheckoutModal() {
  // ========== States existants ========== 
  const [zipCode, setZipCode] = useState("");
  const [ville, setVille] = useState("");
  const [reference, setReference] = useState("");
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [adresse, setAdresse] = useState("");
  const [pays, setPays] = useState("France");
  const [montant, setMontant] = useState("");
  const [step, setStep] = useState(1);

  // On récupère le point relais via DeliveryMode
  const [selectedRelay, setSelectedRelay] = useState(null);

  const [cgvAccepted, setCgvAccepted] = useState(false);
  const [showCgvError, setShowCgvError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // ========== Exemples de calcul ========== 
  const produitTotal = parseFloat(montant || 0);
  const fraisLivraison = 6; // ex: 6€

  // ========== Avance d'étape ========== 
  const handleContinueToPayment = () => {
    if (!selectedRelay) {
      setErrorMessage("Veuillez sélectionner un point relais avant de continuer.");
      return;
    }
    setErrorMessage("");
    setStep(3);
  };

  // Définir une variable qui vérifie que tous les champs requis sont remplis
const isFormComplete =
reference.trim() &&
nom.trim() &&
prenom.trim() &&
email.trim() &&
telephone.trim() &&
adresse.trim() &&
pays.trim() &&
zipCode.trim() &&
ville.trim() &&
selectedRelay &&
cgvAccepted;


  return (
    <div className="checkout-container" style={{ maxWidth: "500px", margin: "0 auto" }}>
      {/* Bannière */}
      <div style={{ backgroundColor: "#000", color: "#fff", textAlign: "center", padding: "20px 0", marginBottom: "20px", marginLeft: "30px" }}>
        <h1 style={{ margin: 0, fontSize: "2rem", letterSpacing: "0.05em" }}>BAZAR PRO</h1>
        <p style={{ margin: 0, fontSize: "1.2rem", textTransform: "uppercase" }}>
          EN LIVE <span style={{ color: "red" }}>🔴</span>
        </p>
      </div>

      {/* Étape 1 */}
      <h2>Étape 1. Saisir le montant</h2>
      <div className="montant-container">
        <input
          type="number"
          min="1"
          step="1"
          value={montant}
          onChange={(e) => setMontant(e.target.value)}
          className="montant-input"
        />
        <span className="euro-symbol">€</span>
        <button className="valider-btn" onClick={() => setStep(2)}>
          Valider
        </button>
      </div>

      {/* Étape 2 */}
      {step >= 2 && (
        <>
          <h2>Étape 2. Remplir les informations de livraison</h2>

          {/* Champs classiques */}
          <div className="form-row">
            <input type="text" placeholder="Référence" value={reference} onChange={(e) => setReference(e.target.value)} required/>
            <input type="text" placeholder="Nom" value={nom} onChange={(e) => setNom(e.target.value)} required/>
            <input type="text" placeholder="Prénom" value={prenom} onChange={(e) => setPrenom(e.target.value)} required />
          </div>
          <div className="form-row">
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required/>
            <input type="tel" placeholder="Téléphone" value={telephone} onChange={(e) => setTelephone(e.target.value)} required/>
            <input type="text" placeholder="Adresse" value={adresse} onChange={(e) => setAdresse(e.target.value)} required/>
          </div>
          <div className="form-row">
            <input type="text" value={pays} onChange={(e) => setPays(e.target.value)} required />
            <input type="text" placeholder="Code Postal" value={zipCode} onChange={(e) => setZipCode(e.target.value)} required/>
            <input type="text" placeholder="Ville" value={ville} onChange={(e) => setVille(e.target.value)} required />
          </div>

        {/*  <p className="shipping-info">Frais de port facturé une fois lors du premier paiement</p> */}

          <h2>Mode de livraison</h2>


          {/* ========== NOUVEAU : On intègre DeliveryMode ========== */}
          <DeliveryMode
            onRelaySelected={(data) => {
              // On récupère toutes les infos du relais
              setSelectedRelay(data);
            }}
          />

          {/* Erreur si on n’a pas sélectionné de relais */}
          {errorMessage && <p className="error-message">{errorMessage}</p>}

          {/* Checkbox CGV */}
          <div style={{ marginBottom: "10px" }}>
            <label>
              <input
                type="checkbox"
                checked={cgvAccepted}
                onChange={() => {
                  setCgvAccepted(!cgvAccepted);
                  if (showCgvError) setShowCgvError(false);
                }}
              />{" "}
              J'accepte <a href="/cgv" target="_blank" rel="noreferrer">les CGV</a>
            </label>
            {showCgvError && (
              <p style={{ color: "red", marginTop: "5px" }}>
                Veuillez accepter les termes et conditions
              </p>
            )}
          </div>


<button
  onClick={() => {
    // Vérifier que tous les champs sont remplis
    if (
      !reference.trim() ||
      !nom.trim() ||
      !prenom.trim() ||
      !email.trim() ||
      !telephone.trim() ||
      !adresse.trim() ||
      !pays.trim() ||
      !zipCode.trim() ||
      !ville.trim()
    ) {
      setErrorMessage("Veuillez remplir tous les champs du formulaire.");
      return;
    }
    // Vérifier le point relais
    if (!selectedRelay) {
      setErrorMessage("Veuillez sélectionner un point relais.");
      return;
    }
    // Vérifier les CGV
    if (!cgvAccepted) {
      setErrorMessage("Veuillez accepter les conditions générales de vente.");
      return;
    }
    // Si tout est correct, on efface le message d'erreur et on continue
    setErrorMessage("");
    handleContinueToPayment();
  }}
  className="btn continuer-btn"
  style={{
    opacity: (!reference.trim() ||
              !nom.trim() ||
              !prenom.trim() ||
              !email.trim() ||
              !telephone.trim() ||
              !adresse.trim() ||
              !pays.trim() ||
              !zipCode.trim() ||
              !ville.trim() ||
              !selectedRelay ||
              !cgvAccepted)
      ? 0.5
      : 1,
    cursor: (!reference.trim() ||
             !nom.trim() ||
             !prenom.trim() ||
             !email.trim() ||
             !telephone.trim() ||
             !adresse.trim() ||
             !pays.trim() ||
             !zipCode.trim() ||
             !ville.trim() ||
             !selectedRelay ||
             !cgvAccepted)
      ? "not-allowed"
      : "pointer",
  }}
>
  Continuer vers le paiement
</button>

        </>
      )}

      {/* Étape 3 */}
      {step === 3 && (
        <>
          <h2> Étape 3. Mode de paiement</h2>
          <div className="recap-section">
            <div className="recap-totaux">
              <div>
                <strong>Total produits:</strong>
                <div>{produitTotal.toFixed(2)} €</div>
              </div>
              <div>
                <strong>Frais de port:</strong>
                <div>{fraisLivraison.toFixed(2)} €</div>
              </div>
              <div>
                <strong>Total TTC:</strong>
                <div>{(produitTotal + fraisLivraison).toFixed(2)} €</div>
              </div>
            </div>
          </div>


          <div className="my-divStripe">
          <Elements stripe={stripePromise}>
            <CheckoutForm
              montant={montant}
              livraison={{
                reference,
                nom,
                prenom,
                email,
                telephone,
                adresse,
                pays,
                zipCode,
                ville,
                // On passe le point relais sélectionné
                selectedPointRelais: selectedRelay
              }}
            />
          </Elements>
          </div>
        </>
      )}
    </div>
  );
}

export default CheckoutModal;
